import type { WorkspaceRole } from "@/api/types";
import { useStore } from "./store";

// Roles (API plan §6.5): viewers read, follow and share; editors and owners change the worldview. The API
// refuses a viewer's write with 403 either way; the app hides the controls so a viewer never meets that.

export function roleOf(s: { workspaces: { slug: string; role: WorkspaceRole }[]; ws: string | null }): WorkspaceRole | null {
	return s.workspaces.find((w) => w.slug === s.ws)?.role ?? null;
}

export function useRole(): WorkspaceRole | null {
	return useStore(roleOf);
}

/** Whether the signed-in user can change this workspace's worldview. */
export function useCanEdit(): boolean {
	return useStore((s) => roleOf(s) !== "viewer");
}
